import * as React from "react";
// import { Theme, useTheme } from "@mui/material/styles";
// import OutlinedInput from "@mui/material/OutlinedInput";
// import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent, SelectClasses } from "@mui/material/Select";
import { OptionForFilter } from "../../../const/types/optionForFilterType";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function SelectBoxMUI({
  name,
  options,
  classes,
  addLabel,
  className,
  selected,
  setSelected,
}: {
  name: string;
  options: Array<OptionForFilter>;
  classes?: Partial<SelectClasses> | undefined;
  addLabel?: string;
  className?: string;
  selected?: string[];
  setSelected?: React.Dispatch<React.SetStateAction<string[] | undefined>>;
}) {
  // const theme = useTheme();

  const handleChange = (event: SelectChangeEvent<typeof selected>) => {
    const {
      target: { value },
    } = event;
    if (setSelected === undefined) return;
    setSelected(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: "100%", margin: 0 }}>
        {/* <InputLabel id={`selectBox-MUI-${name}`}>{name}</InputLabel> */}
        <Select
          // labelId={`selectBox-MUI-${name}`}
          id={`selectBox-MUI-id-${name}`}
          value={selected}
          onChange={handleChange}
          // input={<OutlinedInput label={name} />}
          MenuProps={MenuProps}
          classes={classes}
          className={className}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {addLabel + " " + option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
